export const NOTIFICATION_TYPE = {
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const NOTIFICATIONS = {
  RECONNECTING: 'RECONNECTING',
  RECONNECTED: 'RECONNECTED',
  CONNECTION_LOST: 'CONNECTION_LOST',
  CONNECTION_SLOW: 'CONNECTION_SLOW',
  BID_PROCESSING_ERROR: 'BID_PROCESSING_ERROR',
  BID_PLACED_WHILE_RESERVE_MET_AND_HIGHEST_BIDDER:
    'BID_PLACED_WHILE_RESERVE_MET_AND_HIGHEST_BIDDER',
  BID_PLACE_ATTEMPT_BY_NON_BIDDER: 'BID_PLACE_ATTEMPT_BY_NON_BIDDER',
  ERROR_PROCESSING_BID: 'ERROR_PROCESSING_BID',
  LOT_CLOSED_BID_REJECTED: 'LOT_CLOSED_BID_REJECTED',
  BID_LOT_EXPIRED: 'BID_LOT_EXPIRED',
  MAX_BID_MET_OR_EXCEEDED: 'MAX_BID_MET_OR_EXCEEDED',
  INVALID_BID_ATTEMPT: 'INVALID_BID_ATTEMPT',
  INVALID_MAX_BID: 'INVALID_MAX_BID',
  RETRYING_BID: 'RETRYING_BID',
  PLACE_INCREMENT_ERROR: 'PLACE_INCREMENT_ERROR',
  AUTO_INCREMENT_PLACED: 'AUTO_INCREMENT_PLACED',
  AUTO_INCREMENT_PLACED_WHILE_HIGHEST_BIDDER:
    'AUTO_INCREMENT_PLACED_WHILE_HIGHEST_BIDDER',
  UNEXPIRED_AUTO_INCREMENT_ALREADY_EXIST:
    'UNEXPIRED_AUTO_INCREMENT_ALREADY_EXIST',
};

export const NOTIFICATIONS_TO_BE_CLEARED = [
  NOTIFICATIONS.BID_PLACED_WHILE_RESERVE_MET_AND_HIGHEST_BIDDER,
  NOTIFICATIONS.BID_PLACE_ATTEMPT_BY_NON_BIDDER,
  NOTIFICATIONS.ERROR_PROCESSING_BID,
  NOTIFICATIONS.LOT_CLOSED_BID_REJECTED,
  NOTIFICATIONS.BID_LOT_EXPIRED,
  NOTIFICATIONS.MAX_BID_MET_OR_EXCEEDED,
  NOTIFICATIONS.INVALID_BID_ATTEMPT,
  NOTIFICATIONS.INVALID_MAX_BID,
  NOTIFICATIONS.PLACE_INCREMENT_ERROR,
  NOTIFICATIONS.AUTO_INCREMENT_PLACED,
  NOTIFICATIONS.AUTO_INCREMENT_PLACED_WHILE_HIGHEST_BIDDER,
  NOTIFICATIONS.UNEXPIRED_AUTO_INCREMENT_ALREADY_EXIST,
];
